import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const getActivePrinciple = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api   
    .get(excludeChars ? `${url.stage.ActivePrinciple}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.ActivePrinciple}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%`), {})    
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newActivePrinciple = async data =>
  api
    .post(url.stage.ActivePrinciple, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editActivePrinciple = async (stateId, data) =>
  api
    .put(`${url.stage.ActivePrinciple}/${stateId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeActivePrinciple = async stateId =>
  api
    .remove(`${url.stage.ActivePrinciple}/${stateId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getActivePrinciple,
  newActivePrinciple,
  editActivePrinciple,
  removeActivePrinciple,
}
